import { drypApi } from "@/services/drypApi";

export type DataPoint = readonly [time: number, value: number];
export type DataSeries = readonly DataPoint[];

interface TimeSeriesRequest {
	structureId: Dryp.StructureId;
	paramId: number;
	from: string;
	to: string;
}

export const timeSeries = {
	getOne: async (request: TimeSeriesRequest): Promise<DataSeries> => {
		const { from, to, structureId, paramId } = request;
		return await drypApi.get<DataSeries>(`/api/timeseries/point/${structureId}/parameter/${paramId}`, {
			params: {
				from,
				to,
				getSubSampled: false,
				getRaw: false,
				getAdjusted: true,
			},
		});
	},
};
